import React, { useContext, useState } from 'react'
import { EmployeeFormContext } from './EmployeeForm'
import {
  Alert,
  AlertTitle,
  Box,
  Checkbox,
  FormControlLabel,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material'

const ControlledDrugs = () => {
  const { formValues, setFormValues } = useContext(EmployeeFormContext)
  return (
    <Box component={Paper} padding={3}>
      <Stack gap={1}>
        <Typography variant="title">Controlled Drugs</Typography>
        <FormControlLabel
          label="Carries Controlled Drugs"
          control={
            <Checkbox
              checked={!!formValues?.employee?.carriesControlledDrugs}
              onChange={(e) =>
                setFormValues((prev) => ({
                  ...prev,
                  employee: {
                    ...prev.employee,
                    carriesControlledDrugs: e.target.checked,
                  },
                }))
              }
              color="anPurple"
            />
          }
        />
        {formValues?.employee?.carriesControlledDrugs && (
          <TextField
            value={formValues?.employee?.controlledDrugsPin ?? ''}
            onChange={(e) =>
              setFormValues((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  controlledDrugsPin: e.target.value,
                },
              }))
            }
            fullWidth
            label="Controlled Drugs Pin"
          />
        )}
        <Alert severity="info">
          <AlertTitle>
            Select this if the employee carries Controlled Drugs for which they
            are personally responsible.
          </AlertTitle>
          Selecting this enables AmbuNet to track individual CD checks and
          include them in KPI reports.
        </Alert>
      </Stack>
    </Box>
  )
}

export default ControlledDrugs
